import { createSlice } from "@reduxjs/toolkit";
import { campCauses } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const causesSlice = createSlice({
  name: "causes",
  initialState: data,
  reducers: {
    causesSlice(state) {
      state.isLoading = true;
    },
    causesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    causesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    causesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const causesHandler = () => async (dispatch: any) => {
  try {
    dispatch(causesAction.causesSlice());
    const response: any = await campCauses();
    dispatch(causesAction.causesSliceSuccess(response));
  } catch (e: any) {
    dispatch(causesAction.causesSliceFailure(e?.response?.data?.message));
    dispatch(causesAction.causesSliceReset());
  }
};
export default causesSlice.reducer;
export const causesAction = causesSlice.actions;
